import { forwardRef, useRef, useEffect } from 'react';

function useEnsuredForwardedRef(forwardedRef) {
  const ensuredRef = useRef(forwardedRef && forwardedRef.current);
  useEffect(() => {
    if (!forwardedRef) {
      return;
    }
    // eslint-disable-next-line no-param-reassign
    forwardedRef.current = ensuredRef.current;
  }, [forwardedRef]);
  return ensuredRef;
}
function ensuredForwardRef(Component) {
  return /*#__PURE__*/forwardRef((props, ref) => {
    const ensuredRef = useEnsuredForwardedRef(ref);
    return Component(props, ensuredRef);
  });
}

export { useEnsuredForwardedRef as default, ensuredForwardRef };
